import { useEffect, useState } from "react";
import { CalendarDays, MapPin, ArrowUpRight } from "lucide-react";
import { PageHeader } from "@/components/shared/PageHeader";
import { EmptyState } from "@/components/shared/States";
import { StaggerGroup, StaggerItem } from "@/components/shared/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { fetchContent } from "@/lib/contentApi";

export default function Events() {
  useSeo("Events", "Upcoming ASAI expert sessions, workshops and events.");
  const [items, setItems] = useState(null);
  useEffect(() => { fetchContent("events").then(setItems).catch(() => setItems([])); }, []);

  return (
    <div data-testid="page-events">
      <PageHeader overline="Events" titleLines={["Sessions, workshops", "& events"]} description="Expert sessions, workshops and events hosted by ASAI." />
      <section className="bg-white py-16 md:py-24">
        <div className="container-asai">
          {items === null ? null : items.length === 0 ? (
            <EmptyState title="No events scheduled yet" description="Upcoming events will be listed here. Check back soon!" />
          ) : (
            <StaggerGroup className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="events-grid">
              {items.map((e) => (
                <StaggerItem key={e.id} className="flex flex-col overflow-hidden rounded-2xl border border-navy/10 bg-white">
                  {e.image && <img src={e.image} alt={e.title} loading="lazy" className="aspect-[16/10] w-full object-cover" />}
                  <div className="flex flex-1 flex-col gap-3 p-6">
                    <h3 className="font-heading text-xl text-navy">{e.title}</h3>
                    <div className="flex flex-col gap-1 text-sm text-navy/60">
                      {e.date && <span className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-orange" /> {e.date}</span>}
                      {e.location && <span className="flex items-center gap-2"><MapPin className="h-4 w-4 text-orange" /> {e.location}</span>}
                    </div>
                    {e.description && <p className="text-sm text-navy/60">{e.description}</p>}
                    {e.link && <a href={e.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center gap-1 pt-2 text-sm font-medium text-orange">Register <ArrowUpRight className="h-4 w-4" /></a>}
                  </div>
                </StaggerItem>
              ))}
            </StaggerGroup>
          )}
        </div>
      </section>
    </div>
  );
}
